import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Pagination, Typography, Button, Select } from "antd";
import { SyncOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";

// Constants
import * as Constants from "./constant";
const { Text } = Typography;
const { Option } = Select;

class Counter extends React.Component {

  renderCursorPagination = () => {
    const {
      loading,
      pagination: {
        limit,
        hasNext,
        hasPrevious,
      },
      handlePageSizeChange,
      handleCursorNext,
      handleCursorPrev,
    } = this.props;

    return (
      <div className="d-flex align-items-center">
        <Button
          size="small"
          icon={<LeftOutlined />}
          disabled={!hasPrevious || loading}
          onClick={handleCursorPrev}
        >
          Previous
        </Button>
        <Button
          size="small"
          className="ml-1"
          disabled={!hasNext || loading}
          onClick={handleCursorNext}
        >
          Next <RightOutlined />
        </Button>
        <Select
          size="small"
          className="ml-2"
          value={String(limit)}
          disabled={loading}
          onChange={(pageSize) => handlePageSizeChange(null, pageSize)}
        >
          {Constants.LIST_LAYOUT_PAGE_SIZE.map((size) => (
            <Option key={size} value={size}>{size} / page</Option>
          ))}
        </Select>
      </div>
    );
  }

  renderOffsetPagination = () => {
    const {
      handlePaginationChange,
      handlePageSizeChange,
      defaultCurrent,
      pagination: {
        limit,
        total,
      },
    } = this.props;

    return (
      <Pagination
        size="small"
        showSizeChanger
        total={total}
        pageSize={limit}
        current={defaultCurrent}
        onChange={handlePaginationChange}
        onShowSizeChange={handlePageSizeChange}
        pageSizeOptions={Constants.LIST_LAYOUT_PAGE_SIZE}
      />
    );
  }
  
  render() {
    const {
      onClick,
      loading,
      className,
      selectedTitle,
      pagination: {
        offset,
        total,
        count,
      },
      useCursorPagination,
      dataSource,
      selected,
      lastUpdated
    } = this.props;
    const itemCount = dataSource.length;
    const pageCount = count || itemCount;
    const rangeStart = useCursorPagination
      ? null
      : (itemCount === 0 ? 0 : offset + 1 || 0);
    const rangeEnd = useCursorPagination
      ? null
      : count + offset || 0;

    return (
      <div className={`d-flex justify-content-between align-items-center ${className}`}>
        <div className="d-flex align-items-center">
          <Typography.Text>
            {useCursorPagination ? (
              <>
                Showing {pageCount} {pageCount === 1 ? "item" : "items"}
              </>
            ) : (
              <>
                {rangeStart} - {rangeEnd}{" "}
                <FormattedMessage id="listLayout.of" /> {total || 0}
              </>
            )}
            <SyncOutlined 
              className="ml-1"
              onClick={onClick} 
              type="sync" 
              spin={loading}
            />
            {selected > 0 && (
              <span style={{ marginLeft: 8 }}>
                Selected {selected} {selected > 1 ? `${selectedTitle}s` : selectedTitle}
              </span>
            )}
            {lastUpdated != null && (
              <Text type="secondary" className="ml-1">Last updated: {lastUpdated}</Text> 
            )}
          </Typography.Text>
        </div>
        <div className="d-flex align-items-center">
          {useCursorPagination
            ? this.renderCursorPagination()
            : this.renderOffsetPagination()}
        </div>
      </div>
    );
  }
}

Counter.propTypes = {
  spin: PropTypes.bool,
  lastUpdated: PropTypes.string,
  className: PropTypes.string,
  selectedTitle: PropTypes.string,
  defaultCurrent: PropTypes.number,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  useCursorPagination: PropTypes.bool,
  handleCursorNext: PropTypes.func,
  handleCursorPrev: PropTypes.func,
  pagination: PropTypes.shape({
    limit: PropTypes.number,
    offset: PropTypes.number,
    count: PropTypes.number,
    total: PropTypes.number,
    hasNext: PropTypes.bool,
    hasPrevious: PropTypes.bool,
    nextCursor: PropTypes.string,
    prevCursor: PropTypes.string,
  }),
  handlePaginationChange: PropTypes.func,
  handlePageSizeChange: PropTypes.func,
  dataSource: PropTypes.array,
  selected: PropTypes.number,
};

Counter.defaultProps = {
  selected: 0,
  selectedTitle: "Item",
  pagination: {
    limit: 0,
    offset: 0,
    count: 0,
    total: 0,
  },
};

export default Counter;